var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.total))+" paid for "+_vm._s(_vm._f("formatCount")(_vm.count,'piece'))+" "),(_vm.items && _vm.items.length === _vm.count && _vm.total !== _vm.sumTotal)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.sumTotal))+" sum does not match ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }